import CustomizeCard from "./Card";

const DashboardTopCards = ({ dashboardStats }) => {
  const stats = [
    {
      subtext: "Total Companies",
      title: dashboardStats?.total_companies,
      bottomtext: "Companies"
    },
    {
      subtext: "Total Employees",
      title: dashboardStats?.total_employees,
      bottomtext: "Company Employees"
    },
    {
      subtext: "Total Departments",
      title: dashboardStats?.department_number,
      bottomtext: "Departments"
    },
    {
      subtext: "Total Divisions",
      title: dashboardStats?.division_number,
      bottomtext: "Divisions"
    },
  ]
  return (
    <div className="Dashboard_Top_Card">
      {stats.map((data, index) => (
        <CustomizeCard
          key={index}
          bottomtext={data.bottomtext}
          subtext={data.subtext}
          title={data.title}
        />
      ))}
    </div>
  );
};

export default DashboardTopCards;
